"use strict";

import "./ColorPicker.css";
import Picker from "./../Picker";
import Button from "./../Button";
import React from "react";

export default class ColorPicker extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			color: this.props.color,
			picker: false
		};
	}
	
	componentWillReceiveProps(nextProps) {
		if ("color" in nextProps)
			this.setState({color: nextProps.color});
	}

	renderColorButton(color){
		let ButtonStyle = {
			backgroundColor: color
		}
		return(
			<td key={color}>
				<Button
					className="ColorPicker"
					style={ButtonStyle}
					onClick={()=>{
							this.setState({color, picker: false});
							this.props.onChange(color);
						}
					}			
				/>
			</td>
		);
	}
	
	renderColorRow(colorRow){
		return(
			<tr key={colorRow[0]}>
				{colorRow.map(color => this.renderColorButton(color))}
			</tr>
		);
	}
	
	render(){
		let mainButtonStyle = {
			backgroundColor: this.state.color
		};
		
		return (
			<Button disabled={this.props.disabled} className="ColorPicker ColorInput" style={mainButtonStyle} onClick={_ => {this.setState({picker: !this.state.picker})}}>
				<Picker className="ColorPicker" shown={this.state.picker} onWindowClick={() => this.setState({picker: false})}>
					<table>
						<tbody>
						{
							this.constructor.COLORS.map(colorRow => this.renderColorRow(colorRow))
						}
						</tbody>
					</table>
				</Picker>
			</Button>
		);
	}
	
}

ColorPicker.propTypes = {
	color: React.PropTypes.string,
	onChange: React.PropTypes.func,
	disabled: React.PropTypes.bool
};

ColorPicker.defaultProps = {
	color: "#000000",
	onChange: color => {},
	disabled: false
};

ColorPicker.COLORS = [	["#F34235", "#FE5621", "#9B26AF", "#6639B6"],
						["#3E50B4", "#2095F2", "#00BBD3", "#009587"],
						["#4BAE4F", "#8AC249", "#CCDB38", "#FEEA3A"],
						["#FEC006", "#FE9700", "#785447", "#5F7C8A"],
						["#FFFFFF", "#F0F0F0", "#808080", "#000000"]];



// WEBPACK FOOTER //
// ./~/vwa/components/ColorPicker/ColorPicker.jsx